import { memo, useEffect } from "react";
import { validateYupWithFeedback } from "services/forms/validation/feedback";
import { NotificationEntityType } from "services/api/notifications/types";
import { ENTITY_TYPE_DEFAULT_TEMPLATES } from "services/api/notifications/consts";
import { NOTIFICATION_ENTITY_TYPE_SCHEMA } from "../validation";
import { StepProps } from "../types";
import EntityTypeSelector from "./EntityTypeSelector";

// Prvi korak nosi samo odabir grupe. Tip notifikacije, kanali i sadržaj poruke stoje na
// sljedećem koraku — zajedno su bili predugački za jedan ekran.
const Step1BasicInfo: React.FC<StepProps> = ({
  formValues,
  setFormValues,
  errors,
  setErrors,
  registerValidator,
  isEdit,
}) => {
  useEffect(() => {
    if (registerValidator) {
      registerValidator(() =>
        validateYupWithFeedback(formValues, NOTIFICATION_ENTITY_TYPE_SCHEMA, setErrors)
      );
    }
  }, [formValues]);

  const handleEntityTypeChange = (value: number) => {
    const isCustom = value === NotificationEntityType.Custom;
    const defaults = !isEdit ? ENTITY_TYPE_DEFAULT_TEMPLATES[value] : undefined;
    setFormValues((prev) => ({
      ...prev,
      entityType: value,
      isCustom,
      ...(defaults ? { title: defaults.title, messageTemplate: defaults.messageTemplate } : {}),
      ...(isCustom ? {
        daysBeforeExpiry: null,
        isRepeating: false,
        repeatIntervalDays: null,
        repeatCount: null,
        notifyIfDateMissing: false,
        scope: 0
      } : {}),
    }));
    setErrors(({ entityType, ...rest }) => rest);
  };

  return (
    <div className="flex justify-center h-full px-4 mt-[100px]">
      <div className="w-full max-w-4xl">
        <EntityTypeSelector
          selectedType={formValues.entityType}
          error={errors.entityType}
          onChange={handleEntityTypeChange}
        />
      </div>
    </div>
  );
};

export default memo(Step1BasicInfo);
